import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="89" height="138" viewBox="0 0 89 138" fill="none">
    <path
      d="M37.987 47.4639V74.2398H11.5396C11.7151 73.853 11.9604 73.4966 12.2648 73.192L37.987 47.4639Z"
      fill="#57B3DF"
    />
    <path
      d="M11.2158 85.0957V112.252C11.2158 113.242 12.0175 114.043 13.0066 114.043H30.7706C31.7597 114.043 32.5614 113.242 32.5614 112.252V106.261C32.5614 99.6982 37.7809 94.228 44.3419 94.1428C51.0082 94.0563 56.4395 99.4352 56.4395 106.083V112.252C56.4395 113.242 57.2411 114.043 58.2302 114.043H75.9942C76.9833 114.043 77.785 113.242 77.785 112.252V85.0957H11.2158Z"
      fill="#FFD064"
    />
    <path
      d="M37.9885 44.931C37.9885 33.9396 46.8972 25.0293 57.8868 25.0293C68.8764 25.0293 77.7853 33.9396 77.7853 44.931H37.9885Z"
      fill="#EAB14D"
    />
    <path
      d="M67.2933 36.4279C67.2933 39.5019 66.5258 42.3962 65.1736 44.9314H77.7852C77.7852 36.0635 71.9854 28.5515 63.9731 25.9795C66.0641 28.9307 67.2933 32.5356 67.2933 36.4279Z"
      fill="#E49824"
    />
    <path
      d="M73.0818 85.0957V105.721C73.0818 107.719 71.462 109.339 69.4639 109.339H56.4395V112.252C56.4395 113.242 57.2411 114.043 58.2302 114.043H75.9942C76.9833 114.043 77.785 113.242 77.785 112.252V85.0957H73.0818Z"
      fill="#FFC250"
    />
    <path
      d="M13.0066 114.043H30.7706C31.7597 114.043 32.5614 113.241 32.5614 112.252V109.339H11.2158V112.252C11.2158 113.241 12.0177 114.043 13.0066 114.043Z"
      fill="#FFC250"
    />
    <path
      d="M77.785 74.24V85.0954H11.2158V75.7247C11.2158 75.2071 11.3286 74.7002 11.54 74.24H77.785Z"
      fill="#95D6A4"
    />
    <path
      d="M73.0818 74.2412H77.7851V85.0966H73.0818V74.2412Z"
      fill="#78C2A4"
    />
    <path
      d="M48.8423 44.9307V74.2403H37.9886V44.9307H48.8423Z"
      fill="#E877A7"
    />
    <path
      d="M77.7852 44.9307V74.2403H66.9315V44.9307H77.7852Z"
      fill="#E877A7"
    />
    <path
      d="M77.7852 44.9307V74.2403H73.0819V44.9307H77.7852Z"
      fill="#DD5790"
    />
  </SvgIcon>
));
